"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvestorType = exports.TimeUnit = exports.OptionGrantsType = exports.OptionGrantsVestingType = exports.NoteStatus = exports.TransactionType = exports.TrusteeType = exports.EntityType = void 0;
var EntityType;
(function (EntityType) {
    EntityType["INDIVIDUAL"] = "individual";
    EntityType["COMPANY"] = "company";
    EntityType["TRUST"] = "trust";
    EntityType["SMSF"] = "smsf";
    EntityType["JOINT"] = "joint";
})(EntityType = exports.EntityType || (exports.EntityType = {}));
var TrusteeType;
(function (TrusteeType) {
    TrusteeType["INDIVIDUAL"] = "individual";
    TrusteeType["COMPANY"] = "company";
})(TrusteeType = exports.TrusteeType || (exports.TrusteeType = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["ISSUE"] = "issue";
    TransactionType["TRANSFER"] = "transfer";
    TransactionType["ALLOCATE"] = "allocate";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
var NoteStatus;
(function (NoteStatus) {
    NoteStatus["ISSUE"] = "issue";
    NoteStatus["CONVERTED"] = "converted";
    NoteStatus["PAID"] = "paid";
})(NoteStatus = exports.NoteStatus || (exports.NoteStatus = {}));
var OptionGrantsVestingType;
(function (OptionGrantsVestingType) {
    OptionGrantsVestingType["TIME"] = "time";
    OptionGrantsVestingType["MANUAL"] = "manual";
})(OptionGrantsVestingType = exports.OptionGrantsVestingType || (exports.OptionGrantsVestingType = {}));
var OptionGrantsType;
(function (OptionGrantsType) {
    OptionGrantsType["EMPLOYEE"] = "employee";
    OptionGrantsType["NON_EMPLOYEE"] = "non-employee";
})(OptionGrantsType = exports.OptionGrantsType || (exports.OptionGrantsType = {}));
var TimeUnit;
(function (TimeUnit) {
    TimeUnit["MONTH"] = "MONTH";
    TimeUnit["YEAR"] = "YEAR";
})(TimeUnit = exports.TimeUnit || (exports.TimeUnit = {}));
var InvestorType;
(function (InvestorType) {
    InvestorType["SOPHISTICATED"] = "Sophisticated";
    InvestorType["CROWD_SOURCED"] = "Crowd-sourced";
    InvestorType["RETAIL"] = "Retail";
    InvestorType["EMPLOYEE"] = "Employee";
})(InvestorType = exports.InvestorType || (exports.InvestorType = {}));
//# sourceMappingURL=index.js.map